import { ServiceAccountGovernance } from "@/features/admin/service-account-governance";

export default function AdminServiceAccountsPage() {
  return <ServiceAccountGovernance />;
}
